import styled from 'styled-components';

export default styled.strong`
  color: var(--blue);
`;
